module.exports = __webpack_public_path__ + "static/img/200166.29dc1f08.png";